// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1RAe7","modalForm":"UpgradeEpcsModal_modalForm__2WFU8","modalFooter":"UpgradeEpcsModal_modalFooter__21YSa"};